import Detail from '../../views/event/Detail.vue';

// イベント情報詳細
window.Vue.component('event-detail', Detail);
